import * as core from '../../../../../../../core'
import * as stakeholderPerceivedAttitude from '../stakeholder-perceived-attitude'

export const RESOURCE = {
  payload: {
    description: 'Positive',
    enumId: core.dms.models.Enum.Id.from({
      partialId: stakeholderPerceivedAttitude.RESOURCE.payload.partialId,
    }),
    id: 'Positive',
    name: 'Positive',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
